export default __webpack_public_path__ + "static/media/google-play-button.810cc04c.png";